//Stack class

class Stack extends Array {
  constructor() {
    super();
  }

  peek() {
    return this[this.length - 1];
  }

  isEmpty() {
    return this.length === 0;
  }

  clear() {
    this.length = 0;
  }

  size() {
    return this.length;
  }
}

export default Stack;
